import { sendDelete, sendGet, sendPost, sendPut } from "api/restUtil";
import {useEffect, useMemo, useState} from 'react';
import SearchList from 'components/SearchList';
import ReactDataTableDisplay from 'components/DataTable/ReactDataTableDisplay';
import { getTodayStr, isEmpty } from "js/common";
import BasicButton from "components/button/BasicButton";
import OrderDetailModal from "./OrderDetailModal";
import { hasAdminAuth } from "api/commonUtil";
import { excelDownload } from "js/commonExcel";

// 상품 주문 목록 (DB에 저장된 변경 데이터)
function ProductOrderList() {

	//데이터 목록
	const [ dataList, setDataList ] = useState([]);
	//초기 검색 조건 데이터
	const [ initialCondition, setInitialCondition] = useState({});
	//검색 데이터
	const [ condition, setCondition] = useState({});
	// 페이징 정보
    const [pagingInfo, setPagingInfo] = useState({});
	// 주문 상세 팝업
	const [isOpenOrderDetailPop, setIsOpenOrderDetailPop] = useState(false);
	// 주문 상세 팝업 표시할 주문 번호
	const [selectedOrderId, setSelectedOrderId] = useState(null);
	// 가맹점 목록
	const [branchOptionList, setBranchOptionList] = useState([]);

	//검색 조건
	const conditionList = useMemo(() => ([
		{
			title : "주문 상태",
			col : "productOrderStatus",
			type : "commonCodeSelect",
			grpCd: "PRODUCT_ORDER_STATUS"
		},
		{
			title: "상태변경 일시",
			col: ["lastChangedDateFrom", "lastChangedTimeFrom", "lastChangedDateTo", "lastChangedTimeTo"],
			type: "dateAndTimeTerm",
			required: true,
			sizeClass: "doubleSize",

		},
		{
			title: "결제일자",
			col: ["paymentDateFrom", "paymentDateTo"],
			type: "dayPickerInputTerm",
		},
		hasAdminAuth() ? 
		{
			title: "가맹점",
			col: "branchId",
			type: "select",
			option: [
				{label: "전체", value: ""},
				...branchOptionList
			],
		}: null,
		{
			title: "주문번호",
			col: "orderId",
			type: "input",
		},
		{
			title: "상품주문번호",
			col: "productOrderId",
			type: "input",
		},
		{
			title : "표시건수",
			col : "cntPerPage",
			type : "select",
			option: [
				{label: "10개씩보기", value: 10},
				{label: "20개씩보기", value: 20},
				{label: "50개씩보기", value: 50},
				{label: "100개씩보기", value: 100},
			],
		},

	]), [branchOptionList]);
	
	
	// const getRowspan = (data) => {
	// 	return data.productOrderCnt;
	// }	
	
	//데이터 테이블 컬럼
	const columns = useMemo(() =>[
		// { header : "주문번호", col : "orderId", cellWidth: "100", rowspan: getRowspan},
		{ header : "주문상세", col : "dispOrderId", type: "modButton", cellWidth : "100", label: "보기", onClick: (d) => setSelectedOrderId(d.orderId) },
		{ header : "주문번호", col : "orderId", notView: true},
		{ header : "주문번호", col : "dispOrderId", cellWidth: "150"},
		{ header : "상품주문번호", col : "productOrderId", cellWidth : "150" },
		{ header : "지점명", col : "branchName", cellWidth : "100" },
		{ header : "상품명", col : "productName", cellWidth : "250" },
		{ header : "옵션", col : "productOption", cellWidth : "100" },
		{ header : "수량", col : "quantity", cellWidth : "50" },
		{ header : "상품주문상태코드", col : "productOrderStatus", notView: true },
		{ header : "상품주문상태", col : "productOrderStatusNm", notView: true },
		{ header : "상품주문상태", col : "productOrderStatusNm2", cellWidth : "100" },
		{ header : "배송상태", col : "deliveryStatusNm2", cellWidth : "100" },
		{ header : "주문일시", col : "paymentDate", cellWidth : "150" },
		{ header : "발주상태", col : "placeOrderStatusNm", cellWidth : "100" },
		{ header : "클레임구분코드", col : "claimType", notView: true},
		{ header : "클레임구분", col : "claimTypeNm", cellWidth : "100" },
		{ header : "클레임상태코드", col : "claimStatus", notView: true },
		{ header : "클레임상태", col : "claimStatusNm", cellWidth : "100" },
	], []);

	const excelColumns = useMemo(() => [
		{ header : "주문번호", col : "dispOrderId", cellWidth: "150"},
		{ header : "상품주문번호", col : "productOrderId", cellWidth : "150" },
		{ header : "지점명", col : "branchName", cellWidth : "100" },
		{ header : "상품명", col : "productName", cellWidth : "250" },
		{ header : "옵션", col : "productOption", cellWidth : "100" },
		{ header : "수량", col : "quantity", cellWidth : "50" },
		{ header : "주문일시", col : "paymentDate", cellWidth : "150" },
	], []);

	useEffect(() =>{
		const initData = async () => {
			
			//초기 검색 조건
			const today = getTodayStr();
			const newCond = {lastChangedDateFrom: today, lastChangedTimeFrom: "00:00", lastChangedDateTo: today, lastChangedTimeTo: "23:59",
				paymentDateFrom: today, paymentDateTo: today, cntPerPage: 10};
			setInitialCondition(newCond);
			searchList(newCond);
		};

		initData();

		const makeBranchOptionList = async() => {
			const branchList = await sendGet("/api/mgmt/branch", {cntPerPage: 99999999});
			if(branchList.respCode === "SUCCESS") {
				const branchOptions = branchList.data.list.map(d => {
					return {label: d.branchName, value: d.branchId};
				});

				setBranchOptionList(branchOptions);
			}
		}
		if(hasAdminAuth()) {
			makeBranchOptionList();
		}


	}, []);

	useEffect(() => {
		// selectedOrderId가 있으면 팝업 표시. 없으면 팝업 닫기.
		setIsOpenOrderDetailPop(selectedOrderId != null);
	}, [selectedOrderId]);

	//목록 조회
	/*
	const searchList1 = async (cond = {}) => {

		const tmpCond = {...cond};
		if(tmpCond.lastChangedDateFrom) {
			if(!tmpCond.lastChangedTimeFrom) {
				tmpCond.lastChangedTimeFrom = "00:00";
			}
			tmpCond.lastChangedDateFrom = tmpCond.lastChangedDateFrom + " " +  tmpCond.lastChangedTimeFrom;
		}
		if(tmpCond.lastChangedDateTo) {
			if(!tmpCond.lastChangedTimeTo) {
				tmpCond.lastChangedTimeTo = "23:59";
			}
			tmpCond.lastChangedDateTo = tmpCond.lastChangedDateTo + " " +  tmpCond.lastChangedTimeTo;
		}
		if(tmpCond.paymentDateFrom) {
			tmpCond.paymentDateFrom = tmpCond.paymentDateFrom + " " +  "00:00";
		}
		if(tmpCond.paymentDateTo) {
			tmpCond.paymentDateTo = tmpCond.paymentDateTo + " " +  "23:59";
		}

		delete tmpCond.lastChangedTimeFrom;
		delete tmpCond.lastChangedTimeTo;
		
		let result = await sendGet("/api/order/prdOrdrList", tmpCond);
		if(result.respCode === "SUCCESS"){

			setCondition(cond);

			let list = result.data.list;
			list.forEach((d, idx) => {
				if(idx === 0 || result.data.list[idx-1].orderId !== d.orderId) {
					d.dispOrderId = d.orderId;
				}
			});

			list = result.data.list.map(d => ({
				...d,
				productOrderStatusNm2: d.productOrderStatus === "PAYED" && d.placeOrderStatus === "OK" ? "상품준비중": d.productOrderStatusNm,
				deliveryStatusNm2: d.productOrderStatus === "DELIVERYING" && isEmpty(d.deliveryStatusNm) ? "배송준비중" : d.deliveryStatusNm,
			}));
			setDataList(list);
			setPagingInfo({...result.data, list: [], searchFnc: searchList, searchCond: cond });
		}
	}
		*/

	const searchList = async (cond = {}) => {
		const result = await searchAndReturn(cond);
		if(result != null) {
			setCondition(result.condition);
			setDataList(result.list);
			setPagingInfo(result.pagingInfo);
		}
	};

	const searchAndReturn = async(cond) => {
		const tmpCond = {...cond};
		if(tmpCond.lastChangedDateFrom) {
			if(!tmpCond.lastChangedTimeFrom) {
				tmpCond.lastChangedTimeFrom = "00:00";
			}
			tmpCond.lastChangedDateFrom = tmpCond.lastChangedDateFrom + " " +  tmpCond.lastChangedTimeFrom;
		}
		if(tmpCond.lastChangedDateTo) {
			if(!tmpCond.lastChangedTimeTo) {
				tmpCond.lastChangedTimeTo = "23:59";
			}
			tmpCond.lastChangedDateTo = tmpCond.lastChangedDateTo + " " +  tmpCond.lastChangedTimeTo;
		}
		if(tmpCond.paymentDateFrom) {
			tmpCond.paymentDateFrom = tmpCond.paymentDateFrom + " " +  "00:00";
		}
		if(tmpCond.paymentDateTo) {
			tmpCond.paymentDateTo = tmpCond.paymentDateTo + " " +  "23:59";
		}

		delete tmpCond.lastChangedTimeFrom;
		delete tmpCond.lastChangedTimeTo;
		
		let result = await sendGet("/api/order/prdOrdrList", tmpCond);
		if(result.respCode === "SUCCESS"){

			// setCondition(cond);

			let list = result.data.list;
			list.forEach((d, idx) => {
				if(idx === 0 || result.data.list[idx-1].orderId !== d.orderId) {
					d.dispOrderId = d.orderId;
				}
			});

			list = result.data.list.map(d => ({
				...d,
				productOrderStatusNm2: d.productOrderStatus === "PAYED" && d.placeOrderStatus === "OK" ? "상품준비중": d.productOrderStatusNm,
				deliveryStatusNm2: d.productOrderStatus === "DELIVERYING" && isEmpty(d.deliveryStatusNm) ? "배송준비중" : d.deliveryStatusNm,
			}));
			// setDataList(list);
			// setPagingInfo({...result.data, list: [], searchFnc: searchList, searchCond: cond });
			const pageInfo = {...result.data, list: [], searchFnc: searchList, searchCond: cond };

			return {list: list, pagingInfo : pageInfo, condition: cond};
		}

		return null;

	}

	const orderListExcel = async () => {
		const resultData = await searchAndReturn({...condition, cntPerPage: pagingInfo.totalCnt, pageNo: 1});
		const excelData = resultData.list;
		const fileName = "주문_" + getTodayStr().replace(/-/g, "") + ".xlsx";
		const sheetName = "주문내역";
		excelDownload(excelColumns, excelData, fileName, sheetName);
	}

	return (
		<div className="ant-tabs-tabpane">
			<SearchList conditionList={conditionList} onSearch={searchList} initialData={initialCondition} />

			<div className="table-buttons mg-t-10 mg-b-10">
				
				<button onClick={() => orderListExcel()} className="table-btn btn-excel">
					Excel
				</button>
				{/* <ExcelButton
					columns={columns}
					data={dataList}
					fileName={"주문_" + getTodayStr().replace(/-/g, "") + "_" + pagingInfo.pageNo + ".xlsx"}
					sheetName={"주문내역"}
				/> */}
			</div>

			<ReactDataTableDisplay
				columns={columns}
				customDatas={dataList}
				hideCheckBox={true}
				// percentageWidth={true}
				isPageNation={false}
				pagingInfo={pagingInfo}
				// rowClick={"checkbox"}
			/>

			<OrderDetailModal
				isOpen={isOpenOrderDetailPop}
				initData={{orderId: selectedOrderId}}
				onClose={()=> {setSelectedOrderId(null);}}
				title={`주문상세 [${selectedOrderId}]`}
			/>

		</div>
	);
}

export default ProductOrderList;